import { useCallbackWithAnalytics } from '@atlaskit/analytics-next';
import { LoadingButton } from '@atlaskit/button';
import { N30, N80 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React from 'react';
import { text } from './styled';

export const StyledSubmitButton = styled(LoadingButton)`
  font-family: ${text};
  font-weight: 500;
  svg {
    margin: 0;
  }

  :hover {
    background-color: #0049b0;
  }

  :disabled,
  :disabled:hover {
    color: ${N80} !important;
    background-color: ${N30};
    opacity: 0.6;
  }
  &.devops {
    margin-top: 30px;
  }
`;

export const SubmitButton = ({ label = '', ...props }) => {
  const handler = useCallbackWithAnalytics(() => undefined, {
    eventName: 'reactSignUpFormSubmitButtonClicked',
    data: {
      event: 'clicked', // event verb, in past tense (eg, "clicked")
      eventComponent: 'submitButton', // name of component being interacted with, in camelCase
      label,
      uuid: 'reactSignUpFormSubmitButton' // required for Magnolia events, unique id for a given component if available
    }
  });

  return (
    <StyledSubmitButton {...props} onClick={handler}>
      {props.children}
    </StyledSubmitButton>
  );
};
